<template>
  <div class="px-0">
    <v-sheet elevation="3" class="mt-3 mb-2">
      <!-- <small>
        {{ $store.state.MlbModule.operator }}
        {{ $store.state.MlbModule.operatorGameType }}</small
      > -->
      <div class="tablenewdesign">
        <!-- <small>{{ this.slates }}</small> -->
        <v-data-table
          :headers="computedHeaders"
          :items="getPlayers"
          item-key="name"
          class="elevation-1 mlb-Table"
          height="850"
          sort-by="DraftKingsSalary"
          sort-desc
          :footerProps="footerProps"
          mobile-breakpoint="0"
        >
          <!-- header -->
          <template
            v-for="h in computedHeaders"
            v-slot:[`header.${h.value}`]="{ computedHeaders }"
          >
            <v-tooltip bottom :key="h.text">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.hint }}</span>
            </v-tooltip>
          </template>
          <!-- header -->

          <!-- OpponentRank -->
          <template v-slot:item.OpponentRank="{ item }" class="mt-1">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-avatar size="25" rounded v-on="on">
                  <v-icon
                    :style="[
                      item.OpponentRank <= 9
                        ? { color: 'red' }
                        : item.OpponentRank > 10 && item.OpponentRank <= 20
                        ? { color: 'black' }
                        : { color: 'green' },
                    ]"
                    >mdi-account-group-outline
                  </v-icon>
                </v-avatar>
                <p class="ml-1">{{ item.OpponentRank }}</p>
              </template>
              <span class="caption">Opponent Rank</span>
            </v-tooltip>
          </template>

          <!-- player name -->
          <template v-slot:item.Name="{ item }">
            <v-row justify="center" class="mr-2">
              <!-- //* avatar -->
              <div>
                <v-avatar v-if="item.PhotoUrl" width="37" height="48">
                  <img :src="item.PhotoUrl" />
                </v-avatar>

                <v-avatar
                  v-if="!item.PhotoUrl && item.Team === 'DEN'"
                  width="37"
                  height="48"
                >
                  <img src="/DEN.svg" />
                </v-avatar>

                <v-avatar
                  v-if="!item.PhotoUrl && item.Team === 'NYJ'"
                  width="37"
                  height="48"
                >
                  <img src="/NYJ.svg" />
                </v-avatar>
              </div>
              <!-- //* avatar ends-->

              <!--//* status -->
              <div class="d-flex align-start mt-n4 indicator">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-col
                      cols="2"
                      md="3"
                      sm="1"
                      v-show="item.InjuryStatus == null"
                      v-on="on"
                      v-bind="attrs"
                    >
                      <status-indicator status="positive" pulse />
                    </v-col>
                  </template>
                  <span>Healthy</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-col
                      cols="2"
                      md="3"
                      sm="1"
                      v-show="item.InjuryStatus == 'Out'"
                      v-on="on"
                      v-bind="attrs"
                    >
                      <status-indicator status="negative" pulse />
                    </v-col>
                  </template>
                  <span>Out</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-col
                      cols="2"
                      md="3"
                      sm="1"
                      v-on="on"
                      v-bind="attrs"
                      v-show="item.InjuryStatus == 'Questionable'"
                    >
                      <status-indicator status="intermediary" pulse />
                    </v-col>
                  </template>
                  <span>Questionable</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-col
                      cols="2"
                      md="3"
                      sm="1"
                      v-on="on"
                      v-bind="attrs"
                      v-show="
                        item.InjuryStatus == 'Probable' ||
                        item.InjuryStatus == 'Doubtful'
                      "
                    >
                      <status-indicator status="active" pulse />
                    </v-col>
                  </template>
                  <span>Probable</span>
                </v-tooltip>
              </div>
              <!--//* status ends-->

              <div class="d-flex align-center">
                <!--//* name -->
                <router-link
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="caption"
                >
                  <span v-if="item.newsstatus === 1" class="blue--text">
                    {{ item.Name }}
                    <v-icon color="blue" size="15">mdi-newspaper</v-icon>
                  </span>
                  <span v-else> {{ item.Name }}</span>
                </router-link>
                <!--//* name ends -->
              </div>
            </v-row>
          </template>
          <!-- player ends -->

          <!-- opponent name -->
          <template v-slot:item.OppPitcherName="{ item }">
            <div>
              <!--//* name -->
              <router-link
                :to="{
                  name: 'PlayerDetail',
                  params: {
                    playerId: item.OppPitcherId,
                    SportId: item.SportId,
                  },
                }"
                style="text-decoration: none"
                class="caption"
              >
                <!-- <span v-if="item.newsstatus === 1" class="blue--text">
                    {{ item.OppPitcherName }}
                    <v-icon color="blue" size="15">mdi-newspaper</v-icon>
                  </span> -->
                <span class="blue--text">{{ item.OppPitcherName }}</span>
              </router-link>
              <!--//* name ends -->
            </div>
          </template>
          <!-- opponent name ends-->

          <!-- batting order -->
          <template v-slot:item.BattingOrder="{ item }">
            <div class="d-flex align-center">
              <v-chip
                v-if="!!(item.BattingOrderConfirmed === 'true')"
                class="ma-2"
                color="light-green"
                text-color="black"
                large
              >
                &#10003; {{ item.BattingOrder ? item.BattingOrder : "_" }}
              </v-chip>

              <v-chip
                v-else
                class="ma-2"
                color="#CFD8DC"
                text-color="black"
                large
              >
                PO ({{ item.BattingOrder ? item.BattingOrder : "_" }})
              </v-chip>
            </div>
          </template>
          <!-- batting order -->

          <!-- position -->
          <template v-slot:item.DraftKingsPosition="{ item }">
            <p class="caption" v-if="slates[0].Operator == 'DraftKings'">
              {{ item.DraftKingsPosition }}
            </p>
            <p v-else class="caption">{{ item.FanDuelPosition }}</p>
          </template>
          <!-- position ends -->

          <!-- salary -->
          <template v-slot:item.DraftKingsSalary="{ item }">
            <p
              v-if="slates[0].Operator == 'DraftKings'"
              class="caption green--text"
            >
              {{ item.DraftKingsSalary }}
            </p>
            <p v-else class="caption green--text">{{ item.FanDuelSalary }}</p>
          </template>
          <!-- salary ends -->

          <!-- matchup -->
          <template v-slot:item.Opponent="{ item }">
            <span class="caption" v-if="item.HomeOrAway == 'AWAY'">
              {{ item.Team }}
            </span>
            <span class="caption" v-else>{{ item.Opponent }}</span
            >&nbsp; <small class="overline">@</small>&nbsp;
            <span class="caption" v-if="item.HomeOrAway == 'HOME'">
              {{ item.Team }}
            </span>
            <span class="caption" v-else>{{ item.Opponent }}</span>
          </template>
          <!-- matchup ends -->

          <!--//* DK Fp -->
          <template v-slot:item.FPPDdraftking="{ item }">
            <p
              class="caption"
              v-if="slates[0].Operator == 'DraftKings' && planType !== 'Free'"
            >
              ${{ item.FPPDdraftking >> 0 }}
            </p>

            <img v-else src="/favicon.ico" height="30" alt="upgrade_logo" />
          </template>
          <!--//* DK Fp ends -->

          <!--//* FD Fp -->
          <template v-slot:item.FPPDfanduel="{ item }">
            <p
              v-if="slates[0].Operator == 'FanDuel' && planType !== 'Free'"
              class="caption"
            >
              ${{ item.FPPDfanduel >> 0 }}
            </p>
            <img v-else src="/favicon.ico" height="30" alt="upgrade_logo" />
          </template>
          <!--//* FD Fp ends -->

          <!-- FPPG -->
          <template v-slot:item.FPPG="{ item }">
            <p class="caption">{{ item.FPPG >> 0 }}</p>
          </template>
          <!-- FPPG ends -->

          <!--//* DK projection -->
          <template v-slot:item.DraftKingsProjection="{ item }">
            <template
              v-if="slates[0].Operator == 'DraftKings' && planType !== 'Free'"
              class="caption"
            >
              <v-text-field
                class="mt-1 projection"
                :id="'proj' + item._id"
                dense
                solo
                :value="item.DraftKingsProjection"
                @keydown="updateProjection($event, item)"
              ></v-text-field>
            </template>
            <img v-else src="/favicon.ico" height="30" alt="upgrade_logo" />
          </template>
          <!--//*DK projection ends -->

          <!--//* FD projection -->
          <template v-slot:item.FandDualProjection="{ item }">
            <template
              v-if="slates[0].Operator == 'FanDuel' && planType !== 'Free'"
              class="caption"
            >
              <v-text-field
                class="mt-1 projection"
                :id="'proj' + item._id"
                dense
                solo
                :value="item.FandDualProjection"
                @keydown="updateProjection($event, item)"
              ></v-text-field>
            </template>

            <img v-else src="/favicon.ico" height="30" alt="upgrade_logo" />
          </template>
          <!--//* FD projection ends -->

          <!-- fanDuelVal -->
          <template v-slot:item.FanDualVal="{ item }">
            <p v-if="slates[0].Operator == 'DraftKings'" class="caption">
              {{ item.DraftKingsVal.toFixed(2) }}
            </p>
            <p v-else class="caption">{{ item.FanDualVal.toFixed(2) }}</p>
          </template>
          <!-- fanDuelVal ends-->

          <!-- min% -->
          <template v-slot:item.min="{ item }">
            <v-text-field
              v-if="planType !== 'Free'"
              class="mt-1 minimun dis"
              :id="'min_' + item._id"
              dense
              solo
              placeholder="0"
              v-model="item.min"
              @blur="setExposure($event, item)"
              :disabled="item.type == 'lock'"
            ></v-text-field>

            <img v-else src="/favicon.ico" height="30" alt="upgrade_logo" />
          </template>
          <!-- min% ends -->

          <!-- max% -->
          <template v-slot:item.max="{ item }">
            <v-text-field
              v-if="planType !== 'Free'"
              class="mt-1 maximum"
              :id="'max_' + item._id"
              solo
              dense
              placeholder="100"
              v-model="item.max"
              @blur="setExposure($event, item)"
              :disabled="item.type == 'lock'"
            ></v-text-field>
            <img v-else src="/favicon.ico" height="30" alt="upgrade_logo" />
          </template>
          <!-- max% ends -->

          <!-- Player action(exclude, lock) block start -->
          <template v-slot:item.type="{ item }">
            <v-row class="mt-n6" justify="space-around">
              <template v-if="item.type == 'lock'">
                <!-- lock player button-->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      fab
                      dark
                      :id="'Lk_' + item._id + item.type"
                      color="green darken-3"
                      @click="unlockExposure($event, item)"
                    >
                      <v-icon>mdi-shield-lock-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Lock</span>
                </v-tooltip>

                <!--//* Position type for fanduel only.. -->
                <template
                  v-if="
                    slates[0].Operator == 'FanDuel' &&
                    $parent.radio == 'others' &&
                    item.type == 'lock'
                  "
                >
                  <small>
                    {{ checkPosition(exposure, item) }}
                  </small>
                </template>

                <!--//* Position type for fanduel only.. -->

                <!-- exclude player button -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      x-small
                      fab
                      :id="'Ex_' + item._id + item.type"
                      color="blue"
                      :disabled="true"
                      v-on="on"
                    >
                      <v-icon> mdi-window-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Exclude</span>
                </v-tooltip>
              </template>

              <template v-else>
                <!-- lock player button-->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      fab
                      dark
                      :id="'Lk_' + item._id + item.type"
                      color="blue"
                      @click="lockExposure($event, item)"
                    >
                      <v-icon>mdi-shield-lock-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Lock</span>
                </v-tooltip>

                <!-- exclude player button -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      x-small
                      fab
                      dark
                      :id="'Ex_' + item._id + item.type"
                      :color="item.type == 'exclude' ? 'red' : 'blue'"
                      v-on="on"
                      @click="setExclude($event, item)"
                    >
                      <v-icon> mdi-window-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Exclude</span>
                </v-tooltip>

                <!--//* Position type for fanduel only.. -->
                <template
                  v-if="
                    slates[0].Operator == 'FanDuel' &&
                    $parent.radio == 'others' &&
                    item.type == 'exclude'
                  "
                >
                  <small>
                    {{ checkPosition(exposure, item) }}
                  </small>
                </template>

                <!--//* Position type for fanduel only.. -->
              </template>
            </v-row>
          </template>
          <!-- Player action(exclude, lock) block end-->
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { guid } from "@/mixins/guid.js";
import _ from "lodash";

export default {
  name: "MlbOptimizerTable",
  mixins: [guid],
  props: {
    playerDetails: {
      type: Array,
      default: () => [],
    },
    selectionD: {
      type: String,
      default: () => "",
    },
    selectionDS: {
      type: String,
      default: () => "",
    },
    selectionF: {
      type: String,
      default: () => "",
    },
    selectionFS: {
      type: String,
      default: () => "",
    },
    slates: {
      type: Array,
      default: [],
    },
    slateID: {
      type: String,
      default: "",
    },
    defaultSport: {
      type: String,
      default: "",
    },
    defaultOptimizer: {
      type: String,
      default: "",
    },
    defaultGameType: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      footerProps: {
        "items-per-page-options": [15, 30, 50, 60, -1],
        "disable-pagination": true,
      },
      DKheaders: [
        {
          text: "Player",
          hint: "name",
          value: "Name",
          sortable: false,
          align: "center",
          width: "200px",
        },

        {
          text: "Action",
          hint: "lock/exclude action",
          value: "type",
          align: "center",
          width: "100px",
          sortable: true,
          sort: (a, b) => {
            if (a > b) {
              // //console.log("a", a);
              return 1;
            }
            if (a < b) {
              // //console.log("b", b);
              return -1;
            }
            return 0;
          },
        },
        {
          text: "",
          hint: "Batting Order",
          value: "BattingOrder",
          width: "50px",
        },
        { text: "Team", hint: "team", value: "Team", align: "center" },
        {
          text: "Position",
          hint: "position",
          value: "DraftKingsPosition",
          sortable: false,
          align: "center",
        },
        {
          text: "Projection Own",
          hint: "projection ownership",
          value: "ProjectionOwnership",
          align: "center",
        },
        {
          text: "Salary($)",
          hint: "salary",
          value: "DraftKingsSalary",
          align: "center",
        },
        {
          text: "Game",
          hint: "game",
          value: "Opponent",
          sortable: false,
          align: "center",
          // width: '120px',
        },

        {
          text: "Pitcher",
          hint: "Pitcher",
          value: "OppPitcherName",
          sortable: false,
          align: "center",
          // width: '120px',
        },
        // { text: '', value: 'OpponentRank', align: 'center' },
        {
          text: "FP",
          hint: "Fantasy Points per $",
          value: "FPPDdraftking",
          align: "center",
          // width: '30px',
        },
        {
          text: "FPPG",
          hint: "Fantasy point per game",
          value: "FPPG",
          align: "center",
          // width: '30px',
        },
        {
          text: "Proj.",
          hint: "projection",
          value: "DraftKingsProjection",
          align: "center",
          width: "100px",
        },
        {
          text: "Min%",
          hint: "minimum",
          value: "min",
          sortable: false,
          align: "center",
          width: "90px",
        },
        {
          text: "Max%",
          hint: "maximum",
          value: "max",
          sortable: false,
          align: "center",
          width: "90px",
        },
      ],
      FDheaders: [
        {
          text: "Player",
          hint: "name",
          value: "Name",
          sortable: false,
          align: "center",
          width: "200px",
        },
        {
          text: "Action",
          hint: "lock/exclude action",
          value: "type",
          align: "center",
          width: "100px",
          sortable: true,
          sort: (a, b) => {
            if (a > b) {
              // //console.log("a", a);
              return 1;
            }
            if (a < b) {
              // //console.log("b", b);
              return -1;
            }
            return 0;
          },
        },
        {
          text: "",
          hint: "Batting Order",
          value: "BattingOrder",
          width: "50px",
        },
        { text: "Team", hint: "team", value: "Team", align: "center" },
        {
          text: "Position",
          hint: "position",
          value: "FanDuelPosition",
          sortable: false,
          align: "center",
        },
        {
          text: "Salary($)",
          hint: "salary",
          value: "FanDuelSalary",
          align: "center",
        },
        {
          text: "Game",
          hint: "game",
          value: "Opponent",
          sortable: false,
          align: "center",
          // width: '120px',
        },
        {
          text: "Pitcher",
          hint: "Pitcher",
          value: "OppPitcherName",
          sortable: false,
          align: "center",
          // width: '120px',
        },
        {
          text: "FP",
          hint: "Fantasy Points per $",
          value: "FPPDfanduel",
          align: "center",
          // width: '30px',
        },
        {
          text: "FPPG",
          hint: "Fantasy point per game",
          value: "FPPG",
          align: "center",
          // width: '30px',
        },
        {
          text: "Proj.",
          hint: "projection",
          value: "FandDualProjection",
          align: "center",
          width: "100px",
        },
        {
          text: "Min%",
          hint: "minimum",
          value: "min",
          sortable: false,
          align: "center",
          width: "110px",
        },
        {
          text: "Max%",
          hint: "maximum",
          value: "max",
          sortable: false,
          align: "center",
          width: "110px",
        },
      ],
      // minRule: [
      //   (v) => (!v && v >= 0 && v <= 100) || "Min 0 % or above",
      //   (v) => !!/^[0-9]*$/.test(v) || "Must be number",
      // ],
      // maxRule: [(v) => (v >= 0 && v <= 100) || "Max 100 % or below"],
      userId: localStorage.getItem("user"),
    };
  },

  computed: {
    ...mapState("MlbModule", ["position", "exposure"]),
    ...mapGetters("MlbModule", [
      "getFilterByPosition",
      "getFilterBySingle",
      "getFilterByPositionInFanduel",
    ]),

    computedHeaders() {
      if (this.defaultOptimizer) {
        if (this.defaultOptimizer == "DraftKings") {
          return this.DKheaders;
        } else {
          return this.FDheaders;
        }
      }
    },
    getPlayers() {
      if (!this.playerDetails.length == 0) {
        if (
          this.slates[0]?.Operator == "DraftKings" &&
          this.slates[0]?.OperatorGameType == "Classic"
        ) {
          return this.getFilterByPosition(this.selectionD);
        } else if (
          this.slates[0]?.Operator == "DraftKings" &&
          this.$parent.radio == "others"
        ) {
          return this.getFilterBySingle(this.selectionDS);
        } else if (
          this.slates[0]?.Operator == "FanDuel" &&
          this.$parent.radio == "others"
        ) {
          return this.getFilterByPositionInFanduel(this.selectionFS);
        } else if (
          this.slates[0]?.Operator == "FanDuel" &&
          this.slates[0]?.OperatorGameType == "Classic"
        ) {
          return this.getFilterByPosition(this.selectionF);
        }
      } else return;
    },
  },

  methods: {
    checkPosition(exposureArr, player) {
      if (exposureArr.length == 0) return;
      let finalValue = "";
      exposureArr.find((element) => {
        if (player.PlayerID == element.playerId && element.type !== "") {
          if (element.type !== "" && element.positiontype == "1") {
            finalValue = "(Mvp)";
            // return "Mvp";
          } else if (element.type !== "" && element.positiontype == "2") {
            finalValue = "(Util)";
          } else if (element.type !== "" && element.positiontype == "3") {
            finalValue = "(Util2)";
          } else if (element.type !== "" && element.positiontype == "4") {
            finalValue = "(Util3)";
          } else if (element.type !== "" && element.positiontype == "5") {
            finalValue = "(Util4)";
          }
        }
      });
      //console.log('positionType', finalValue);
      return finalValue;
    },

    //* lock player...
    async lockExposure(event, player) {
      // request parameters
      let salary = 0;
      if (this.slates[0].Operator == "DraftKings") {
        salary = player.DraftKingsSalary;
      } else if (this.slates[0].Operator == "FanDuel") {
        salary = player.FanDuelSalary;
      }
      let payload = {
        user: this.userId,
        slateType: `${this.defaultOptimizer}${this.defaultGameType}`,
        min: 100,
        max: 100,
        slatId: this.slateID,
        playerId: player.PlayerID,
        teamId: player.TeamID,
        type: player.type == "lock" ? "" : "lock",
        slatePlayerID: player.SlatePlayerID,
        sallary: salary,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
        position: player.DraftKingsPosition,
      };

      await this.$store.dispatch("MlbModule/SetExposure", payload).then(() => {
        // debugger;
        // update player info locally
        if (this.defaultGameType == "Single") {
          if (this.exposure[this.exposure.length - 1].hasOwnProperty("_id")) {
            this.updatePlayerInfo(payload);
          } else return;
        } else {
          this.updatePlayerInfo(payload);
        }
      });
    },

    // * unlock player...
    async unlockExposure(event, player) {
      let payload = {
        playerId: player.PlayerID,
        user: this.userId,
        type: player.type == "lock" ? "" : "lock",
        slatId: this.slateID,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
        position: player.DraftKingsPosition,
      };
      await this.$store
        .dispatch("MlbModule/unlockPlayers", payload)
        .then(() => {
          this.updatePlayerInfo(payload);
        });
    },

    // * set exposure...
    async setExposure(event, player) {
      // check if min and max value not set
      // if (player.min != "" && player.max != "") {
      // request parameter
      let salary = 0;
      if (this.slates[0].Operator == "DraftKings") {
        salary = player.DraftKingsSalary;
      } else if (this.slates[0].Operator == "FanDuel") {
        salary = player.FanDuelSalary;
      }

      let payload = {
        user: this.userId,
        min: player.min,
        max: player.max,
        slatId: this.slateID,
        playerId: player.PlayerID,
        teamId: player.TeamID,
        type: "manual",
        slatePlayerID: player.SlatePlayerID,
        sallary: salary,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
        position: player.DraftKingsPosition,
      };

      await this.$store.dispatch("MlbModule/SetExposure", payload).then(() => {
        // update player info locally
        this.updatePlayerInfo(payload);
        /*let params = `${this.slateID}/${this.userId}`;
                    await this.$store.dispatch("MlbModule/getPlayer", params);*/
      });
      // }
    },

    // * set exclude...
    async setExclude(event, player) {
      // request parameters
      let salary = 0;
      if (this.slates[0].Operator == "DraftKings") {
        salary = player.DraftKingsSalary;
      } else if (this.slates[0].Operator == "FanDuel") {
        salary = player.FanDuelSalary;
      }
      let payload = {
        user: this.userId,
        min: "",
        max: "",
        slatId: this.slateID,
        playerId: player.PlayerID,
        teamId: player.TeamID,
        type: player.type == "" ? "exclude" : "",
        slatePlayerID: player.SlatePlayerID,
        sallary: salary,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
        position: player.DraftKingsPosition,
      };
      // dispatch event
      await this.$store
        .dispatch("MlbModule/SetExposure", payload)
        .then(async () => {
          // update player info locally
          this.updatePlayerInfo(payload);
          /*let params = `${this.slateID}/${this.userId}`;
                await this.$store.dispatch("MlbModule/getPlayer", params);*/
        });
    },

    // * set projection...
    updateProjection: _.debounce(function (event, player) {
      let payload = {
        SlateID: this.slateID,
        user: this.userId,
        playerId: player.PlayerID,
        slatePlayerID: player.SlatePlayerID,
        projection: event.target.value,
      };
      //console.log({ alpha: payload.projection });
      this.$store.dispatch("MlbModule/SetProjection", payload).then(() => {
        this.updatePlayerProjection(event, payload);
      });
    }, 2500),

    updatePlayerProjection(evtValue, playerInfo) {
      let index = this.playerDetails.findIndex(
        (_player) => _player.PlayerID === playerInfo.playerId
      );
      // check if player found in list
      if (index !== -1) {
        let player_info = this.playerDetails[index];
        Object.assign(player_info, {
          DraftKingsProjection: evtValue.target.value,
          FandDualProjection: evtValue.target.value,
        });
        // update the player
        this.playerDetails.splice(index, 1, player_info);
        // console.log(
        //   'player',
        //   this.playerDetails.splice(index, 1, player_info)
        // );
      }
    },

    updatePlayerInfo(player) {
      // player index
      if (
        this.slates[0]?.Operator == "DraftKings" &&
        this.$parent.radio == "others"
      ) {
        // //console.log("check is working for other");
        let index = this.playerDetails.findIndex(
          (_player) => _player.playerrandomid === player.playerrandomid
        );
        if (index !== -1) {
          //check if player found in list
          let player_Info = this.playerDetails[index];
          Object.assign(player_Info, {
            min: player.min,
            max: player.max,
            type: player.type,
          });
          // update the player
          this.playerDetails.splice(index, 1, player_Info);
        }
      } else {
        // //console.log("check is working for classic");
        let index = this.playerDetails.findIndex(
          (_player) => _player.PlayerID === player.playerId
        );
        // check if player found in list
        if (index !== -1) {
          let player_info = this.playerDetails[index];
          Object.assign(player_info, {
            min: player.min,
            max: player.max,
            type: player.type,
          });
          // update the player
          this.playerDetails.splice(index, 1, player_info);
        }
      }
    },
  },
};
</script>

<style scoped>
.minimun {
  font-size: 0.9em;
  max-width: 120px;
}

.maximum {
  font-size: 0.9em;
  max-width: 120px;
}

.projection {
  font-size: 0.9em;
  max-width: 120px;
}

.mlb-Table >>> .v-data-table-header__icon {
  opacity: 1;
}

.mlb-Table >>> .v-data-footer__icons-before {
  display: none;
}

.mlb-Table >>> .v-data-footer__icons-after {
  display: none;
}
</style>
